// extracted by css-extract-rspack-plugin
export default {"reviewDocument":"FMiUxhOvt4wgHw3F"};